import { Box, Grid, Typography } from "@mui/material";
import RootComponents from "../../components/common/RootComponents";
import styles from "./PostRequirement.module.css";
import { IoIosAdd } from "react-icons/io";
import SearchJobPost from "./SearchJobPost";
import JobPostTable from "./JobPostTable";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getPostRequirement } from "../../redux/post-requirement/postRequirementSlice";
import { useDispatch, useSelector } from "react-redux";

const JobpostList = () => {
  const [postrequirementList, setpostRequirementList] = useState([])
  const [postrequirement, setpostRequirement] = useState([])

  const [filter, setFilter] = useState({
    jobTitle: '',
    jobType: '',
    location: '',
    formDate: '',
    toDate: ''
  });

  const navigate = useNavigate();
  const dispatch = useDispatch()
  const postRequirement = useSelector((state) => state.postrequirement)

  useEffect(() => {
    dispatch(getPostRequirement())
  }, [])

  useEffect(() => {
    setpostRequirementList(postRequirement?.data?.jobs)
    setpostRequirement(postRequirement?.data?.jobs)
  }, [postRequirement])

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value
    });
  };

  const handleOnSearch = () => {
    const filteredClients = postrequirement.filter(requirement => {
      const jobTitleMatch = requirement.job_title.toLowerCase().includes(filter.jobTitle.toLowerCase());
      const jobTypeMatch = requirement.job_type.toLowerCase().includes(filter.jobType.toLowerCase());
      const locationMatch = requirement.location.toLowerCase().includes(filter.location.toLowerCase());
      let dateMatch = true;
      if (filter.formDate && filter.toDate) {
        const clientDate = new Date(requirement.created_at);
        const fromDate = new Date(filter.formDate);
        const toDate = new Date(filter.toDate);
        dateMatch = clientDate >= fromDate && clientDate <= toDate;
      }

      return jobTitleMatch && locationMatch && jobTypeMatch && dateMatch;
    });

    setpostRequirementList(filteredClients)
  }

  const handleOnClear = () => {
    setFilter({
      jobTitle: '',
      jobType: '',
      location: '',
      formDate: '',
      toDate: ''
    })
    setpostRequirementList(postrequirement)
  }

  return (
    // <RootComponents>
      <Box className={styles.candidate_structure}>
        {/* <Box className={styles.candidate_listing_text} sx={{ marginBottom: '14px' }}>
          <Typography sx={{ color: 'customTextColor' }}>
            <b>Job Post List</b>
          </Typography>
          <span>
            <button
              style={{ backgroundColor: '#4285f4' }}
              onClick={() => navigate("/post-job-requirement")}
            >
              Job Post <IoIosAdd style={{ fontSize: '25px' }} />
            </button>
          </span>
        </Box> */}

        <Box className={styles.track_submissions_heading}>
          <Box>
            <Typography sx={{ fontSize: '25px !important' }}>102</Typography>
            <Typography>Post since 22/02/2024 </Typography>
            <Typography >Rank 02 </Typography>
          </Box>
          <button onClick={() => navigate("/post-job-requirement")}>Job Post <IoIosAdd style={{ fontSize: '25px' }} /></button>
        </Box>

        <Box sx={{ padding: '10px 0 ', backgroundColor: '#fff', marginBottom: '14px' }}>
          {/* <Grid container >
            <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
              <TableCard
                image={<BsViewList className="card_icons" style={{ fontSize: '30px' }} />}
                count="214"
                text=" No. of Job Post "
                customStyle="10px 10px 0 15px; background-color: white;"
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
              <TableCard
                image={<BsSend className="card_icons" style={{ fontSize: '27px' }} />}
                count="274"
                text="Post Reaching "
                customStyle={{ backgroundColor: 'white' }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
              <TableCard
                image={<IoMailOpenOutline className="card_icons" style={{ fontSize: '30px' }} />}
                count="152"
                text="E-Mail Delivered"
                customStyle={{ backgroundColor: 'white' }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
              <TableCard
                image={<PiUserPlus className="card_icons" style={{ fontSize: '31px' }} />}
                count="25"
                text="Existing Candidates "
                customStyle={{ backgroundColor: 'white' }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={2.4} lg={2.4} xl={2.4}>
              <TableCard
                image={<PiUserPlus className="card_icons" style={{ fontSize: '31px' }} />}
                count="12"
                text="Non Existing Candidates"
                customStyle="10px 16px 0 5px; background-color: white;"

              />
            </Grid>

          </Grid> */}

          <SearchJobPost
            handleInputChange={handleInputChange}
            filter={filter}
            handleOnClear={handleOnClear}
            handleOnSearch={handleOnSearch}
          />
        </Box>
        <JobPostTable postrequirementList={postrequirementList} />
      </Box>
    // </RootComponents>
  );
};

export default JobpostList;
